import React from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { VerifyEmail } from '@components/VerifyEmail'

function VerifyEmailComponent() {
  const { token } = Route.useSearch()
  
  return <VerifyEmail token={token} />
}

export const Route = createFileRoute('/verify-email')({
  component: VerifyEmailComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    token: (search.token as string) || ''
  })
})

